import { useHistory } from 'react-router-dom';
import { Box, Button, Divider, Stack, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { PublicAccount } from '@trnsact/trnsact-shared-types';
import { dealerInfoRowsConfig } from 'modules/aftermarket/partner/constants';

const config = require('../../../../../../config');

interface Props {
  dealerAccount: PublicAccount;
  partnerLinkMetrics: any;
}

export const DealerInfoCard = ({ dealerAccount, partnerLinkMetrics }: Props) => {
  const history = useHistory();

  const handleBackClick = () => {
    history.push(`/dealer-management`);
  };

  return (
    <CardContainer
      title={`${dealerAccount?.name}`}
      overTitleActionBtn={
        <Button variant="text" size="small" startIcon={<ChevronLeftIcon />} onClick={handleBackClick}>
          Back
        </Button>
      }
    >
      <Box display="flex">
        {dealerAccount.vendorProfile?.logo && (
          <img
            alt="Dealer Logo"
            style={{ maxHeight: '200px', maxWidth: '250px', marginRight: '30px', objectFit: 'contain' }}
            src={`https://${config.S3_BUCKET_NAME}.s3-us-west-2.amazonaws.com/${dealerAccount.vendorProfile.logo}`}
          />
        )}
        <Stack spacing={1} divider={<Divider orientation="horizontal" flexItem />} flex={1}>
          {dealerInfoRowsConfig.map(row => (
            <Box display="flex" key={row.metricsKey}>
              <Typography variant="subtitle2" component="span" sx={{ flexBasis: '25%' }}>
                {row.label}
              </Typography>
              {row.component ? (
                row.component(partnerLinkMetrics[row.metricsKey])
              ) : (
                <Typography variant="body1" component="span">
                  {row.formatter
                    ? row.formatter(partnerLinkMetrics[row.metricsKey], true)
                    : partnerLinkMetrics[row.metricsKey]}
                </Typography>
              )}
            </Box>
          ))}
        </Stack>
      </Box>
    </CardContainer>
  );
};
